import { environment as coreEnvironment } from '@portal-core/environment/environment';
import { Environment } from '@portal-core/environment/environment.model';

// Deployment-time overrides. Nothing in this workspace assigns mcEnvironment: inject-env.sh in
// MadCloud.Web.Tools/bash writes `<script>window.mcEnvironment={...}</script>` into the built
// index.html from the MC_* env vars (prefix stripped, camelCased), so its keys are Environment
// keys. Reached through `self` here, the same object as `window` on the main thread (most of the
// other apps spell it `window`). Typed rather than `any` so the spread below is checked.
declare const self: { mcEnvironment?: Partial<Environment> };

export const environment: Environment = {
  ...coreEnvironment,
  ...self.mcEnvironment
};
